const enum Error {
    authFailure = 1,
    serverFailure = 2,
    invalidItem = 3,
    invalidWebAbsoluteUrl = 4,
    generic = 5,
    objectNotSupported = 6,
    invalidEmail = 7
}

/**
 * Which API returned an error.
 */
export const enum Category {
    getSharingInformation = 1,
    shareLink = 2,
    shareObject = 3,
    permissions = 4,
    item = 5,
    me = 6,
    drive = 7,
    invite = 8
}

export default Error;
